module.exports = __webpack_public_path__ + "img/chatLi.b1a4c712.svg";